export const keys = {
  get: 'get_module_info',
  update: 'update_module',
  image: 'update_module_cover',
  personalize: 'update_module_personalization',
};
